import { AutogenModelPnnBuilderHistoryDtl, AutogenRowPnnBuilderHistoryDtl } from "./autogen/AutogenModelPnnBuilderHistoryDtl";

export class ModelPnnBuilderHistoryDtl extends AutogenModelPnnBuilderHistoryDtl<RowPnnBuilderHistoryDtl> {
	constructor() {
		super(RowPnnBuilderHistoryDtl);
	}
}

export class RowPnnBuilderHistoryDtl extends AutogenRowPnnBuilderHistoryDtl {
}